import { render, staticRenderFns } from "./TrashDirectory.vue?vue&type=template&id=9e295164&"
import script from "./TrashDirectory.vue?vue&type=script&lang=js&"
export * from "./TrashDirectory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports